// extracted by mini-css-extract-plugin
module.exports = {"root":"privacy-module--root--13oYT"};